import {
  FilterObject,
  MomentService,
  NotificationService,
  UserStore
} from "@digicerba/common";
import {IAuditWebServiceClient, TypeModificationEnum, RechercheMiseAjourDto} from "@resources/resources";
import {ActivatedRoute} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Component, EventEmitter, OnInit, Output} from "@angular/core";

import * as lodash from "lodash";

@Component({
  selector: 'filtres-misesajour',
  templateUrl: './filtres-misesajour.component.html',
  host: { 'class': 'filter' }
})
export class FiltresMisesAJourComponent implements OnInit {

  filterForm: FormGroup;
  modifications: TypeModificationEnum;
  reference: number;

  isFirstConnection : boolean = true;


  @Output() onFiltering: EventEmitter<any> = new EventEmitter();
  filtres: RechercheMiseAjourDto;

  constructor(fb: FormBuilder, momentService: MomentService, private activatedRoute: ActivatedRoute, notificationService: NotificationService,
              private auditWebServiceClient: IAuditWebServiceClient, private userStore: UserStore) {

    let date = this.activatedRoute.snapshot.queryParamMap.get('date');
    if(date && this.isFirstConnection) {
      this.isFirstConnection = false;
      window.location.replace( window.location.href.split('?')[0]);
      this.filterForm = fb.group({
        debut: [new Date(date), Validators.required],
        fin: [new Date(date), Validators.required],
        examen: null,
        modifications: null,
        supprimes: null
      });
    }else{
      this.filterForm = fb.group({
        debut: [momentService.addMonths(new Date(), -3), Validators.required],
        fin: [new Date(), Validators.required],
        examen: null,
        modifications: null,
        supprimes: null
      });
    }

    this.reference = parseInt(this.activatedRoute.snapshot.data['id']);

    this.modifications = this.activatedRoute.snapshot.data['types'];
    lodash.remove(this.modifications, obj => {
      return obj == "SUPP"
    });

    this.filterForm.valueChanges.debounceTime(500).subscribe(() => {
      let debut = this.filterForm.value.debut;
      let fin = this.filterForm.value.fin;

      if(!debut || !fin){
        notificationService.showErrorNotification("MISES_A_JOUR.FILTRE.null");
      } else if (momentService.isWithin6Months(debut, fin)) {
        notificationService.showErrorNotification("MISES_A_JOUR.FILTRE.plage");
      } else {
        this.submit();
      }
    })
  }

  ngOnInit() {
    this.buildFiltering();
    setTimeout(() => this.onFiltering.emit(this.filtres), 0);
  }

  onRemove(filtre: FilterObject<any>) {
    this.submit();
  }

  submit() {
    this.buildFiltering();
    this.onFiltering.emit(this.filtres);
  }

  buildFiltering() {
    this.filtres = new RechercheMiseAjourDto();
    this.filtres.debut = this.filterForm.value.debut;
    this.filtres.fin = this.filterForm.value.fin;
    this.filtres.fin.setHours(23,59,59);

    let values = this.filterForm.value.examen ? this.filterForm.value.examen.split(' ') : null;
    lodash.remove(values, obj => {
      return obj == "";
    })
    if (!values) {
      values = [];
    }
    this.filtres.examen = values;

    this.filtres.modifications = this.filterForm.value.modifications;
    if(this.filterForm.value.supprimes) {
      if (this.filtres.modifications === null) {
        this.filtres.modifications = ["SUPP"];
      } else {
        let index = this.filtres.modifications.indexOf("SUPP");
        console.log(index);
        if( index == -1 ){
          this.filtres.modifications.push("SUPP");
        }
      }
      console.log(this.filtres);
    } else {
        if (this.filtres.modifications !== null) {
          let index = this.filtres.modifications.indexOf("SUPP");
          console.log(index);
          if( index > -1 ){
            this.filtres.modifications.splice(index, 1);

          }
        }
      }

    this.logAuditFiltre();
  }

  logAuditFiltre() {
    let messageAudit = "Client " + this.userStore.getUser().login + " - Recherche catalogue – ";

    messageAudit += JSON.stringify(this.filtres);

    this.auditWebServiceClient.info({message: messageAudit}).subscribe(() => {
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/historique-modifications/filtres/filtres-misesajour.component.ts